var map = {
	"../../patient-dietplan/patient-dietplan.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-dietplan/patient-dietplan.module.ts",
		"common",
		"patient-dietplan.module"
	],
	"./Medical-emergency-code/Medical-emergency-code.module": [
		"../../../../../src/app/configuration/Medical-emergency-code/Medical-emergency-code.module.ts",
		"Medical-emergency-code.module"
	],
	"./action-module-mst/action-module-mst.module": [
		"../../../../../src/app/configuration/action-module-mst/action-module-mst.module.ts",
		"common",
		"action-module-mst.module"
	],
	"./action-role-mst/action-role-mst.module": [
		"../../../../../src/app/configuration/action-role-mst/action-role-mst.module.ts",
		"common",
		"action-role-mst.module"
	],
	"./action-submodule-button-mst/action-submodule-button-mst.module": [
		"../../../../../src/app/configuration/action-submodule-button-mst/action-submodule-button-mst.module.ts",
		"action-submodule-button-mst.module"
	],
	"./action-submodule-mst/action-submodule-mst.module": [
		"../../../../../src/app/configuration/action-submodule-mst/action-submodule-mst.module.ts",
		"common",
		"action-submodule-mst.module"
	],
	"./action-user-role-mst/action-user-role-mst.module": [
		"../../../../../src/app/configuration/action-user-role-mst/action-user-role-mst.module.ts",
		"common",
		"action-user-role-mst.module"
	],
	"./all-patient-queue/all-patient-queue.module": [
		"../../../../../src/app/opd/all-patient-queue/all-patient-queue.module.ts",
		"common",
		"all-patient-queue.module"
	],
	"./application-configuration/application-configuration.module": [
		"../../../../../src/app/configuration/application-configuration/application-configuration.module.ts",
		"common",
		"application-configuration.module"
	],
	"./appointment-list/appointment-list.module": [
		"../../../../../src/app/opd/appointment-list/appointment-list.module.ts",
		"common",
		"appointment-list.module"
	],
	"./bi/bi.module": [
		"../../../../../src/app/mis/bi/bi.module.ts",
		"common",
		"bi.module"
	],
	"./change-password/change-password.module": [
		"../../../../../src/app/configuration/change-password/change-password.module.ts",
		"change-password.module"
	],
	"./checklist-details/checklist-details.module": [
		"../../../../../src/app/operation-theater/ot-schedule/checklist-details/checklist-details.module.ts",
		"common",
		"checklist-details.module"
	],
	"./concent-details/concent-details.module": [
		"../../../../../src/app/operation-theater/ot-schedule/concent-details/concent-details.module.ts",
		"common",
		"concent-details.module"
	],
	"./configShortcut/configShortcut.module": [
		"../../../../../src/app/configuration/configShortcut/configShortcut.module.ts",
		"configShortcut.module"
	],
	"./cpoe-doctoradvice/cpoe-doctoradvice.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-doctoradvice/cpoe-doctoradvice.module.ts",
		"common",
		"cpoe-doctoradvice.module"
	],
	"./cpoe-investigation/cpoe-investigation.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-investigation/cpoe-investigation.module.ts",
		"common",
		"cpoe-investigation.module"
	],
	"./cpoe-prescription/cpoe-prescription.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-emr/emr-cpoe/cpoe-prescription/cpoe-prescription.module.ts",
		"common",
		"cpoe-prescription.module"
	],
	"./current-stock/current-stock.module": [
		"../../../../../src/app/inventory/current-stock/current-stock.module.ts",
		"common",
		"current-stock.module"
	],
	"./dashboard/dashboard.module": [
		"../../../../../src/app/configuration/dashboard/dashboard.module.ts",
		"common",
		"dashboard.module"
	],
	"./doctor-details/doctor-details.module": [
		"../../../../../src/app/operation-theater/ot-schedule/doctor-details/doctor-details.module.ts",
		"doctor-details.module"
	],
	"./doctor-schedule-chart/doctor-schedule-chart.module": [
		"../../../../../src/app/opd/doctor-schedule-chart/doctor-schedule-chart.module.ts",
		"common",
		"doctor-schedule-chart.module"
	],
	"./emr-cpoe/emr-cpoe.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-emr/emr-cpoe/emr-cpoe.module.ts",
		"emr-cpoe.module"
	],
	"./emr-diagnosis/emr-diagnosis.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-emr/emr-diagnosis/emr-diagnosis.module.ts",
		"emr-diagnosis.module"
	],
	"./emr-primaryassessment/emr-primaryassessment.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-emr/emr-primaryassessment/emr-primaryassessment.module.ts",
		"common",
		"emr-primaryassessment.module"
	],
	"./emr-referring-letters/emr-referring-letters.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/emr-referring-letters/emr-referring-letters.module.ts",
		"common",
		"emr-referring-letters.module"
	],
	"./emr-triage/emr-triage.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-emr/emr-triage/emr-triage.module.ts",
		"common",
		"emr-triage.module"
	],
	"./emr-vitaldetails/emr-vitaldetails.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-emr/emr-vitaldetails/emr-vitaldetails.module.ts",
		"emr-vitaldetails.module"
	],
	"./equipment-details/equipment-details.module": [
		"../../../../../src/app/operation-theater/ot-schedule/equipment-details/equipment-details.module.ts",
		"common",
		"equipment-details.module"
	],
	"./followup-list/followup-list.module": [
		"../../../../../src/app/opd/followup-list/followup-list.module.ts",
		"common",
		"followup-list.module"
	],
	"./generate-token/generate-token.module": [
		"../../../../../src/app/opd/generate-token/generate-token.module.ts",
		"common",
		"generate-token.module"
	],
	"./homesortcut/homesortcut.module": [
		"../../../../../src/app/configuration/homesortcut/homesortcut.module.ts",
		"homesortcut.module"
	],
	"./immunization-vaccination-item/immunization-vaccination-item.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient_vaccines/immunization-vaccination-item/immunization-vaccination-item.module.ts",
		"immunization-vaccination-item.module"
	],
	"./import-data/import-data.module": [
		"../../../../../src/app/configuration/import-data/import-data.module.ts",
		"import-data.module"
	],
	"./intra-operative-instruction-details/intra-operative-instruction-details.module": [
		"../../../../../src/app/operation-theater/ot-schedule/intra-operative-instruction-details/intra-operative-instruction-details.module.ts",
		"common",
		"intra-operative-instruction-details.module"
	],
	"./inv-compound-name/inv-compound-name.module": [
		"../../../../../src/app/configuration/inv-compound-name/inv-compound-name.module.ts",
		"common",
		"inv-compound-name.module"
	],
	"./inv-generic-name/inv-generic-name.module": [
		"../../../../../src/app/configuration/inv-generic-name/inv-generic-name.module.ts",
		"common",
		"inv-generic-name.module"
	],
	"./inv-indent-flag/inv-indent-flag.module": [
		"../../../../../src/app/configuration/inv-indent-flag/inv-indent-flag.module.ts",
		"common",
		"inv-indent-flag.module"
	],
	"./inv-item-category/inv-item-category.module": [
		"../../../../../src/app/configuration/inv-item-category/inv-item-category.module.ts",
		"common",
		"inv-item-category.module"
	],
	"./inv-item-company/inv-item-company.module": [
		"../../../../../src/app/configuration/inv-item-company/inv-item-company.module.ts",
		"common",
		"inv-item-company.module"
	],
	"./inv-item-dispensing-type/inv-item-dispensing-type.module": [
		"../../../../../src/app/configuration/inv-item-dispensing-type/inv-item-dispensing-type.module.ts",
		"common",
		"inv-item-dispensing-type.module"
	],
	"./inv-item-group/inv-item-group.module": [
		"../../../../../src/app/configuration/inv-item-group/inv-item-group.module.ts",
		"common",
		"inv-item-group.module"
	],
	"./inv-item-kit-package/inv-item-kit-package.module": [
		"../../../../../src/app/configuration/inv-item-kit-package/inv-item-kit-package.module.ts",
		"common",
		"inv-item-kit-package.module"
	],
	"./inv-item-storage-type/inv-item-storage-type.module": [
		"../../../../../src/app/configuration/inv-item-storage-type/inv-item-storage-type.module.ts",
		"common",
		"inv-item-storage-type.module"
	],
	"./inv-item-sub-category/inv-item-sub-category.module": [
		"../../../../../src/app/configuration/inv-item-sub-category/inv-item-sub-category.module.ts",
		"common",
		"inv-item-sub-category.module"
	],
	"./inv-item-subgroup/inv-item-subgroup.module": [
		"../../../../../src/app/configuration/inv-item-subgroup/inv-item-subgroup.module.ts",
		"common",
		"inv-item-subgroup.module"
	],
	"./inv-item-subtype/inv-item-subtype.module": [
		"../../../../../src/app/configuration/inv-item-subtype/inv-item-subtype.module.ts",
		"common",
		"inv-item-subtype.module"
	],
	"./inv-item-terms-and-condition/inv-item-terms-and-condition.module": [
		"../../../../../src/app/configuration/inv-item-terms-and-condition/inv-item-terms-and-condition.module.ts",
		"common",
		"inv-item-terms-and-condition.module"
	],
	"./inv-item-type/inv-item-type.module": [
		"../../../../../src/app/configuration/inv-item-type/inv-item-type.module.ts",
		"common",
		"inv-item-type.module"
	],
	"./inv-item/inv-item.module": [
		"../../../../../src/app/configuration/inv-item/inv-item.module.ts",
		"common",
		"inv-item.module"
	],
	"./inv-mode-scrapsale/inv-mode-scrapsale.module": [
		"../../../../../src/app/configuration/inv-mode-scrapsale/inv-mode-scrapsale.module.ts",
		"inv-mode-scrapsale.module"
	],
	"./inv-pregnancy-class/inv-pregnancy-class.module": [
		"../../../../../src/app/configuration/inv-pregnancy-class/inv-pregnancy-class.module.ts",
		"common",
		"inv-pregnancy-class.module"
	],
	"./inv-primary-tax/inv-primary-tax.module": [
		"../../../../../src/app/configuration/inv-primary-tax/inv-primary-tax.module.ts",
		"common",
		"inv-primary-tax.module"
	],
	"./inv-service-wise-item-consumption/inv-service-wise-item-consumption.module": [
		"../../../../../src/app/configuration/inv-service-wise-item-consumption/inv-service-wise-item-consumption.module.ts",
		"common",
		"inv-service-wise-item-consumption.module"
	],
	"./inv-store/inv-store.module": [
		"../../../../../src/app/configuration/inv-store/inv-store.module.ts",
		"common",
		"inv-store.module"
	],
	"./inv-supplier/inv-supplier.module": [
		"../../../../../src/app/configuration/inv-supplier/inv-supplier.module.ts",
		"common",
		"inv-supplier.module"
	],
	"./inv-tax/inv-tax.module": [
		"../../../../../src/app/configuration/inv-tax/inv-tax.module.ts",
		"common",
		"inv-tax.module"
	],
	"./inv-therapeutic-class/inv-therapeutic-class.module": [
		"../../../../../src/app/configuration/inv-therapeutic-class/inv-therapeutic-class.module.ts",
		"inv-therapeutic-class.module"
	],
	"./inv-unit-of-measurment/inv-unit-of-measurment.module": [
		"../../../../../src/app/configuration/inv-unit-of-measurment/inv-unit-of-measurment.module.ts",
		"common",
		"inv-unit-of-measurment.module"
	],
	"./lab-record-dashboard/lab-record-dashboard.module": [
		"../../../../../src/app/ipd/patient-emr-dashboard/lab-record-dashboard/lab-record-dashboard.module.ts",
		"lab-record-dashboard.module"
	],
	"./listof-token-generated/listof-token-generated.module": [
		"../../../../../src/app/opd/listof-token-generated/listof-token-generated.module.ts",
		"listof-token-generated.module"
	],
	"./mac-account-head/mac-account-head.module": [
		"../../../../../src/app/configuration/mac-account-head/mac-account-head.module.ts",
		"mac-account-head.module"
	],
	"./mac-accounting-group/mac-accounting-group.module": [
		"../../../../../src/app/configuration/mac-accounting-group/mac-accounting-group.module.ts",
		"common",
		"mac-accounting-group.module"
	],
	"./mac-cost-category/mac-cost-category.module": [
		"../../../../../src/app/configuration/mac-cost-category/mac-cost-category.module.ts",
		"common",
		"mac-cost-category.module"
	],
	"./mac-cost-centre/mac-cost-centre.module": [
		"../../../../../src/app/configuration/mac-cost-centre/mac-cost-centre.module.ts",
		"common",
		"mac-cost-centre.module"
	],
	"./mac-currency/mac-currency.module": [
		"../../../../../src/app/configuration/mac-currency/mac-currency.module.ts",
		"mac-currency.module"
	],
	"./mac-ledger/mac-ledger.module": [
		"../../../../../src/app/configuration/mac-ledger/mac-ledger.module.ts",
		"common",
		"mac-ledger.module"
	],
	"./mac-parent/mac-parent.module": [
		"../../../../../src/app/configuration/mac-parent/mac-parent.module.ts",
		"common",
		"mac-parent.module"
	],
	"./mac-tax-type/mac-tax-type.module": [
		"../../../../../src/app/configuration/mac-tax-type/mac-tax-type.module.ts",
		"common",
		"mac-tax-type.module"
	],
	"./mac-tax/mac-tax.module": [
		"../../../../../src/app/configuration/mac-tax/mac-tax.module.ts",
		"common",
		"mac-tax.module"
	],
	"./mac-transction-type/mac-transction-type.module": [
		"../../../../../src/app/configuration/mac-transction-type/mac-transction-type.module.ts",
		"mac-transction-type.module"
	],
	"./mac-voucher-type/mac-voucher-type.module": [
		"../../../../../src/app/configuration/mac-voucher-type/mac-voucher-type.module.ts",
		"mac-voucher-type.module"
	],
	"./maintance-bed/maintance-bed.module": [
		"../../../../../src/app/ipd/bed-management/under-maintenance/maintance-bed/maintance-bed.module.ts",
		"common",
		"maintance-bed.module"
	],
	"./mbill-advance-against/mbill-advance-against.module": [
		"../../../../../src/app/configuration/mbill-advance-against/mbill-advance-against.module.ts",
		"common",
		"mbill-advance-against.module"
	],
	"./mbill-concession-category/mbill-concession-category.module": [
		"../../../../../src/app/configuration/mbill-concession-category/mbill-concession-category.module.ts",
		"common",
		"mbill-concession-category.module"
	],
	"./mbill-concession-template/mbill-concession-template.module": [
		"../../../../../src/app/configuration/mbill-concession-template/mbill-concession-template.module.ts",
		"common",
		"mbill-concession-template.module"
	],
	"./mbill-doctore-share/mbill-doctore-share.module": [
		"../../../../../src/app/configuration/mbill-doctore-share/mbill-doctore-share.module.ts",
		"common",
		"mbill-doctore-share.module"
	],
	"./mbill-group/mbill-group.module": [
		"../../../../../src/app/configuration/mbill-group/mbill-group.module.ts",
		"common",
		"mbill-group.module"
	],
	"./mbill-item-category/mbill-item-category.module": [
		"../../../../../src/app/configuration/mbill-item-category/mbill-item-category.module.ts",
		"common",
		"mbill-item-category.module"
	],
	"./mbill-item/mbill-item.module": [
		"../../../../../src/app/configuration/mbill-item/mbill-item.module.ts",
		"common",
		"mbill-item.module"
	],
	"./mbill-package/mbill-package.module": [
		"../../../../../src/app/configuration/mbill-package/mbill-package.module.ts",
		"common",
		"mbill-package.module"
	],
	"./mbill-plan/mbill-plan.module": [
		"../../../../../src/app/configuration/mbill-plan/mbill-plan.module.ts",
		"common",
		"mbill-plan.module"
	],
	"./mbill-service-codetype/mbill-service-codetype.module": [
		"../../../../../src/app/configuration/mbill-service-codetype/mbill-service-codetype.module.ts",
		"common",
		"mbill-service-codetype.module"
	],
	"./mbill-service/mbill-service.module": [
		"../../../../../src/app/configuration/mbill-service/mbill-service.module.ts",
		"common",
		"mbill-service.module"
	],
	"./mbill-sub-group/mbill-sub-group.module": [
		"../../../../../src/app/configuration/mbill-sub-group/mbill-sub-group.module.ts",
		"common",
		"mbill-sub-group.module"
	],
	"./mbill-tariff/mbill-tariff.module": [
		"../../../../../src/app/configuration/mbill-tariff/mbill-tariff.module.ts",
		"common",
		"mbill-tariff.module"
	],
	"./mbill-terms-payment/mbill-terms-payment.module": [
		"../../../../../src/app/configuration/mbill-terms-payment/mbill-terms-payment.module.ts",
		"mbill-terms-payment.module"
	],
	"./medical-records/medical-records.module": [
		"../../../../../src/app/ipd/patient-emr-dashboard/medical-records/medical-records.module.ts",
		"medical-records.module"
	],
	"./memr-allergy-sensitivity/memr-allergy-sensitivity.module": [
		"../../../../../src/app/configuration/memr-allergy-sensitivity/memr-allergy-sensitivity.module.ts",
		"common",
		"memr-allergy-sensitivity.module"
	],
	"./memr-allergy/memr-allergy.module": [
		"../../../../../src/app/configuration/memr-allergy/memr-allergy.module.ts",
		"common",
		"memr-allergy.module"
	],
	"./memr-associate-chief-complaint/memr-associate-chief-complaint.module": [
		"../../../../../src/app/configuration/memr-associate-chief-complaint/memr-associate-chief-complaint.module.ts",
		"common",
		"memr-associate-chief-complaint.module"
	],
	"./memr-auto-daily-close-visit/memr-auto-daily-close-visit.module": [
		"../../../../../src/app/configuration/memr-auto-daily-close-visit/memr-auto-daily-close-visit.module.ts",
		"memr-auto-daily-close-visit.module"
	],
	"./memr-chief-complaint/memr-chief-complaint.module": [
		"../../../../../src/app/configuration/memr-chief-complaint/memr-chief-complaint.module.ts",
		"common",
		"memr-chief-complaint.module"
	],
	"./memr-clinical-form/memr-clinical-form.module": [
		"../../../../../src/app/configuration/memr-clinical-form/memr-clinical-form.module.ts",
		"common",
		"memr-clinical-form.module"
	],
	"./memr-clinical-procedure/memr-clinical-procedure.module": [
		"../../../../../src/app/configuration/memr-clinical-procedure/memr-clinical-procedure.module.ts",
		"common",
		"memr-clinical-procedure.module"
	],
	"./memr-disease-category/memr-disease-category.module": [
		"../../../../../src/app/configuration/memr-disease-category/memr-disease-category.module.ts",
		"common",
		"memr-disease-category.module"
	],
	"./memr-disease-sub-category/memr-disease-sub-category.module": [
		"../../../../../src/app/configuration/memr-disease-sub-category/memr-disease-sub-category.module.ts",
		"common",
		"memr-disease-sub-category.module"
	],
	"./memr-disease-type/memr-disease-type.module": [
		"../../../../../src/app/configuration/memr-disease-type/memr-disease-type.module.ts",
		"common",
		"memr-disease-type.module"
	],
	"./memr-doctors-note/memr-doctors-note.module": [
		"../../../../../src/app/configuration/memr-doctors-note/memr-doctors-note.module.ts",
		"common",
		"memr-doctors-note.module"
	],
	"./memr-dose-frequency/memr-dose-frequency.module": [
		"../../../../../src/app/configuration/memr-dose-frequency/memr-dose-frequency.module.ts",
		"memr-dose-frequency.module"
	],
	"./memr-drug-duration/memr-drug-duration.module": [
		"../../../../../src/app/configuration/memr-drug-duration/memr-drug-duration.module.ts",
		"common",
		"memr-drug-duration.module"
	],
	"./memr-drug-instruction/memr-drug-instruction.module": [
		"../../../../../src/app/configuration/memr-drug-instruction/memr-drug-instruction.module.ts",
		"memr-drug-instruction.module"
	],
	"./memr-history-template/memr-history-template.module": [
		"../../../../../src/app/configuration/memr-history-template/memr-history-template.module.ts",
		"common",
		"memr-history-template.module"
	],
	"./memr-icd-code/memr-icd-code.module": [
		"../../../../../src/app/configuration/memr-icd-code/memr-icd-code.module.ts",
		"common",
		"memr-icd-code.module"
	],
	"./memr-referral-template/memr-referral-template.module": [
		"../../../../../src/app/configuration/memr-referral-template/memr-referral-template.module.ts",
		"common",
		"memr-referral-template.module"
	],
	"./memr-symptom/memr-symptom.module": [
		"../../../../../src/app/configuration/memr-symptom/memr-symptom.module.ts",
		"common",
		"memr-symptom.module"
	],
	"./minv-dispensing/minv-dispensing.module": [
		"../../../../../src/app/configuration/minv-dispensing/minv-dispensing.module.ts",
		"minv-dispensing.module"
	],
	"./minv-grn-item-checklist/minv-grn-item-checklist.module": [
		"../../../../../src/app/configuration/minv-grn-item-checklist/minv-grn-item-checklist.module.ts",
		"minv-grn-item-checklist.module"
	],
	"./minv-molecule/minv-molecule.module": [
		"../../../../../src/app/configuration/minv-molecule/minv-molecule.module.ts",
		"common",
		"minv-molecule.module"
	],
	"./mipd-admission-purpose/mipd-admission-purpose.module": [
		"../../../../../src/app/configuration/mipd-admission-purpose/mipd-admission-purpose.module.ts",
		"common",
		"mipd-admission-purpose.module"
	],
	"./mipd-admission-type/mipd-admission-type.module": [
		"../../../../../src/app/configuration/mipd-admission-type/mipd-admission-type.module.ts",
		"mipd-admission-type.module"
	],
	"./mipd-auto-charge/mipd-auto-charge.module": [
		"../../../../../src/app/configuration/mipd-auto-charge/mipd-auto-charge.module.ts",
		"mipd-auto-charge.module"
	],
	"./mipd-bed-amenity/mipd-bed-amenity.module": [
		"../../../../../src/app/configuration/mipd-bed-amenity/mipd-bed-amenity.module.ts",
		"common",
		"mipd-bed-amenity.module"
	],
	"./mipd-bed-class/mipd-bed-class.module": [
		"../../../../../src/app/configuration/mipd-bed-class/mipd-bed-class.module.ts",
		"common",
		"mipd-bed-class.module"
	],
	"./mipd-bed-release-checklist/mipd-bed-release-checklist.module": [
		"../../../../../src/app/configuration/mipd-bed-release-checklist/mipd-bed-release-checklist.module.ts",
		"mipd-bed-release-checklist.module"
	],
	"./mipd-bed/mipd-bed.module": [
		"../../../../../src/app/configuration/mipd-bed/mipd-bed.module.ts",
		"common",
		"mipd-bed.module"
	],
	"./mipd-block/mipd-block.module": [
		"../../../../../src/app/configuration/mipd-block/mipd-block.module.ts",
		"mipd-block.module"
	],
	"./mipd-discharge-destination/mipd-discharge-destination.module": [
		"../../../../../src/app/configuration/mipd-discharge-destination/mipd-discharge-destination.module.ts",
		"mipd-discharge-destination.module"
	],
	"./mipd-discharge-template/mipd-discharge-template.module": [
		"../../../../../src/app/configuration/mipd-discharge-template/mipd-discharge-template.module.ts",
		"mipd-discharge-template.module"
	],
	"./mipd-discharge-type/mipd-discharge-type.module": [
		"../../../../../src/app/configuration/mipd-discharge-type/mipd-discharge-type.module.ts",
		"mipd-discharge-type.module"
	],
	"./mipd-floor/mipd-floor.module": [
		"../../../../../src/app/configuration/mipd-floor/mipd-floor.module.ts",
		"common",
		"mipd-floor.module"
	],
	"./mipd-room-amenity/mipd-room-amenity.module": [
		"../../../../../src/app/configuration/mipd-room-amenity/mipd-room-amenity.module.ts",
		"common",
		"mipd-room-amenity.module"
	],
	"./mipd-room/mipd-room.module": [
		"../../../../../src/app/configuration/mipd-room/mipd-room.module.ts",
		"common",
		"mipd-room.module"
	],
	"./mipd-vital/mipd-vital.module": [
		"../../../../../src/app/configuration/mipd-vital/mipd-vital.module.ts",
		"mipd-vital.module"
	],
	"./mipd-ward/mipd-ward.module": [
		"../../../../../src/app/configuration/mipd-ward/mipd-ward.module.ts",
		"common",
		"mipd-ward.module"
	],
	"./mis-billing/mis-billing.module": [
		"../../../../../src/app/mis/mis-billing/mis-billing.module.ts",
		"common",
		"mis-billing.module"
	],
	"./mis-emergency/mis-emergency.module": [
		"../../../../../src/app/mis/mis-emergency/mis-emergency.module.ts",
		"mis-emergency.module"
	],
	"./mis-inventory/mis-inventory.module": [
		"../../../../../src/app/mis/mis-inventory/mis-inventory.module.ts",
		"common",
		"mis-inventory.module"
	],
	"./mis-investigation/mis-investigation.module": [
		"../../../../../src/app/mis/mis-investigation/mis-investigation.module.ts",
		"common",
		"mis-investigation.module"
	],
	"./mis-ipd/mis-ipd.module": [
		"../../../../../src/app/mis/mis-ipd/mis-ipd.module.ts",
		"common",
		"mis-ipd.module"
	],
	"./mis-misc/mis-misc.module": [
		"../../../../../src/app/mis/mis-misc/mis-misc.module.ts",
		"mis-misc.module"
	],
	"./mis-nursing-station/mis-nursing-station.module": [
		"../../../../../src/app/mis/mis-nursing-station/mis-nursing-station.module.ts",
		"mis-nursing-station.module"
	],
	"./mis-opd/mis-opd.module": [
		"../../../../../src/app/mis/mis-opd/mis-opd.module.ts",
		"common",
		"mis-opd.module"
	],
	"./mis-ot/mis-ot.module": [
		"../../../../../src/app/mis/mis-ot/mis-ot.module.ts",
		"mis-ot.module"
	],
	"./mis-pharmacy/mis-pharmacy.module": [
		"../../../../../src/app/mis/mis-pharmacy/mis-pharmacy.module.ts",
		"common",
		"mis-pharmacy.module"
	],
	"./mis-service/mis-service.module": [
		"../../../../../src/app/mis/mis-service/mis-service.module.ts",
		"common",
		"mis-service.module"
	],
	"./mot-anesthesia-note/mot-anesthesia-note.module": [
		"../../../../../src/app/configuration/mot-anesthesia-note/mot-anesthesia-note.module.ts",
		"mot-anesthesia-note.module"
	],
	"./mot-anesthesia-type/mot-anesthesia-type.module": [
		"../../../../../src/app/configuration/mot-anesthesia-type/mot-anesthesia-type.module.ts",
		"mot-anesthesia-type.module"
	],
	"./mot-intra-operative-instruction/mot-intra-operative-instruction.module": [
		"../../../../../src/app/configuration/mot-intra-operative-instruction/mot-intra-operative-instruction.module.ts",
		"mot-intra-operative-instruction.module"
	],
	"./mot-operation-result/mot-operation-result.module": [
		"../../../../../src/app/configuration/mot-operation-result/mot-operation-result.module.ts",
		"mot-operation-result.module"
	],
	"./mot-operation-theater/mot-operation-theater.module": [
		"../../../../../src/app/configuration/mot-operation-theater/mot-operation-theater.module.ts",
		"mot-operation-theater.module"
	],
	"./mot-post-operative-instruction/mot-post-operative-instruction.module": [
		"../../../../../src/app/configuration/mot-post-operative-instruction/mot-post-operative-instruction.module.ts",
		"mot-post-operative-instruction.module"
	],
	"./mot-pre-operative-instruction/mot-pre-operative-instruction.module": [
		"../../../../../src/app/configuration/mot-pre-operative-instruction/mot-pre-operative-instruction.module.ts",
		"mot-pre-operative-instruction.module"
	],
	"./mot-procedure-category/mot-procedure-category.module": [
		"../../../../../src/app/configuration/mot-procedure-category/mot-procedure-category.module.ts",
		"common",
		"mot-procedure-category.module"
	],
	"./mot-procedure-checklist/mot-procedure-checklist.module": [
		"../../../../../src/app/configuration/mot-procedure-checklist/mot-procedure-checklist.module.ts",
		"common",
		"mot-procedure-checklist.module"
	],
	"./mot-procedure-sub-category/mot-procedure-sub-category.module": [
		"../../../../../src/app/configuration/mot-procedure-sub-category/mot-procedure-sub-category.module.ts",
		"common",
		"mot-procedure-sub-category.module"
	],
	"./mot-procedure-type/mot-procedure-type.module": [
		"../../../../../src/app/configuration/mot-procedure-type/mot-procedure-type.module.ts",
		"mot-procedure-type.module"
	],
	"./mot-surgery-note/mot-surgery-note.module": [
		"../../../../../src/app/configuration/mot-surgery-note/mot-surgery-note.module.ts",
		"mot-surgery-note.module"
	],
	"./mpath-agency/mpath-agency.module": [
		"../../../../../src/app/configuration/mpath-agency/mpath-agency.module.ts",
		"common",
		"mpath-agency.module"
	],
	"./mpath-container/mpath-container.module": [
		"../../../../../src/app/configuration/mpath-container/mpath-container.module.ts",
		"common",
		"mpath-container.module"
	],
	"./mpath-machine/mpath-machine.module": [
		"../../../../../src/app/configuration/mpath-machine/mpath-machine.module.ts",
		"common",
		"mpath-machine.module"
	],
	"./mpath-parameter-method/mpath-parameter-method.module": [
		"../../../../../src/app/configuration/mpath-parameter-method/mpath-parameter-method.module.ts",
		"common",
		"mpath-parameter-method.module"
	],
	"./mpath-parameter-range/mpath-parameter-range.module": [
		"../../../../../src/app/configuration/mpath-parameter/mpath-parameter-range/mpath-parameter-range.module.ts",
		"common",
		"mpath-parameter-range.module"
	],
	"./mpath-parameter-text/mpath-parameter-text.module": [
		"../../../../../src/app/configuration/mpath-parameter-text/mpath-parameter-text.module.ts",
		"common",
		"mpath-parameter-text.module"
	],
	"./mpath-parameter-unit/mpath-parameter-unit.module": [
		"../../../../../src/app/configuration/mpath-parameter-unit/mpath-parameter-unit.module.ts",
		"common",
		"mpath-parameter-unit.module"
	],
	"./mpath-parameter/mpath-parameter.module": [
		"../../../../../src/app/configuration/mpath-parameter/mpath-parameter.module.ts",
		"common",
		"mpath-parameter.module"
	],
	"./mpath-result/mpath-result.module": [
		"../../../../../src/app/configuration/mpath-result/mpath-result.module.ts",
		"mpath-result.module"
	],
	"./mpath-sample-rejection/mpath-sample-rejection.module": [
		"../../../../../src/app/configuration/mpath-sample-rejection/mpath-sample-rejection.module.ts",
		"common",
		"mpath-sample-rejection.module"
	],
	"./mpath-sample-suitability/mpath-sample-suitability.module": [
		"../../../../../src/app/configuration/mpath-sample-suitability/mpath-sample-suitability.module.ts",
		"mpath-sample-suitability.module"
	],
	"./mpath-sample/mpath-sample.module": [
		"../../../../../src/app/configuration/mpath-sample/mpath-sample.module.ts",
		"common",
		"mpath-sample.module"
	],
	"./mpath-test-template/mpath-test-template.module": [
		"../../../../../src/app/configuration/mpath-test-template/mpath-test-template.module.ts",
		"common",
		"mpath-test-template.module"
	],
	"./mpath-test/mpath-test.module": [
		"../../../../../src/app/configuration/mpath-test/mpath-test.module.ts",
		"common",
		"mpath-test.module"
	],
	"./mpath-test/rpath-test-parameter/rpath-test-parameter.module": [
		"../../../../../src/app/configuration/mpath-test/rpath-test-parameter/rpath-test-parameter.module.ts",
		"common",
		"rpath-test-parameter.module"
	],
	"./mrad-film-size/mrad-film-size.module": [
		"../../../../../src/app/configuration/mrad-film-size/mrad-film-size.module.ts",
		"mrad-film-size.module"
	],
	"./mrad-modality/mrad-modality.module": [
		"../../../../../src/app/configuration/mrad-modality/mrad-modality.module.ts",
		"common",
		"mrad-modality.module"
	],
	"./mrad-template-result/mrad-template-result.module": [
		"../../../../../src/app/configuration/mrad-template-result/mrad-template-result.module.ts",
		"common",
		"mrad-template-result.module"
	],
	"./mrad-template/mrad-template.module": [
		"../../../../../src/app/configuration/mrad-template/mrad-template.module.ts",
		"common",
		"mrad-template.module"
	],
	"./mrad-test-category/mrad-test-category.module": [
		"../../../../../src/app/configuration/mrad-test-category/mrad-test-category.module.ts",
		"common",
		"mrad-test-category.module"
	],
	"./mrad-test-template/mrad-test-template.module": [
		"../../../../../src/app/configuration/mrad-test-template/mrad-test-template.module.ts",
		"common",
		"mrad-test-template.module"
	],
	"./mrad-test/mrad-test.module": [
		"../../../../../src/app/configuration/mrad-test/mrad-test.module.ts",
		"common",
		"mrad-test.module"
	],
	"./mst-action/mst-action.module": [
		"../../../../../src/app/configuration/mst-action/mst-action.module.ts",
		"common",
		"mst-action.module"
	],
	"./mst-address-type/mst-address-type.module": [
		"../../../../../src/app/configuration/mst-address-type/mst-address-type.module.ts",
		"common",
		"mst-address-type.module"
	],
	"./mst-address/mst-address.module": [
		"../../../../../src/app/configuration/mst-address/mst-address.module.ts",
		"common",
		"mst-address.module"
	],
	"./mst-ambulance/mst-ambulance.module": [
		"../../../../../src/app/configuration/mst-ambulance/mst-ambulance.module.ts",
		"common",
		"mst-ambulance.module"
	],
	"./mst-ambulancerequisition/mst-ambulancerequisition.module": [
		"../../../../../src/app/configuration/mst-ambulancerequisition/mst-ambulancerequisition.module.ts",
		"common",
		"mst-ambulancerequisition.module"
	],
	"./mst-anaesthesia-note/mst-anaesthesia-note.module": [
		"../../../../../src/app/configuration/mst-anaesthesia-note/mst-anaesthesia-note.module.ts",
		"mst-anaesthesia-note.module"
	],
	"./mst-anaesthesia-type/mst-anaesthesia-type.module": [
		"../../../../../src/app/configuration/mst-anaesthesia-type/mst-anaesthesia-type.module.ts",
		"common",
		"mst-anaesthesia-type.module"
	],
	"./mst-appointment-instruction/mst-appointment-instruction.module": [
		"../../../../../src/app/configuration/mst-appointment-instruction/mst-appointment-instruction.module.ts",
		"mst-appointment-instruction.module"
	],
	"./mst-appointment-reason/mst-appointment-reason.module": [
		"../../../../../src/app/configuration/mst-appointment-reason/mst-appointment-reason.module.ts",
		"common",
		"mst-appointment-reason.module"
	],
	"./mst-appointment-type/mst-appointment-type.module": [
		"../../../../../src/app/configuration/mst-appointment-type/mst-appointment-type.module.ts",
		"common",
		"mst-appointment-type.module"
	],
	"./mst-associated-company/mst-associated-company.module": [
		"../../../../../src/app/configuration/mst-associated-company/mst-associated-company.module.ts",
		"mst-associated-company.module"
	],
	"./mst-auto-charges/mst-auto-charges.module": [
		"../../../../../src/app/configuration/mst-auto-charges/mst-auto-charges.module.ts",
		"mst-auto-charges.module"
	],
	"./mst-bank-branch/mst-bank-branch.module": [
		"../../../../../src/app/configuration/mst-bank-branch/mst-bank-branch.module.ts",
		"mst-bank-branch.module"
	],
	"./mst-bank/mst-bank.module": [
		"../../../../../src/app/configuration/mst-bank/mst-bank.module.ts",
		"mst-bank.module"
	],
	"./mst-bloodgroup/mst-bloodgroup.module": [
		"../../../../../src/app/configuration/mst-bloodgroup/mst-bloodgroup.module.ts",
		"mst-bloodgroup.module"
	],
	"./mst-booking-type/mst-booking-type.module": [
		"../../../../../src/app/configuration/mst-booking-type/mst-booking-type.module.ts",
		"common",
		"mst-booking-type.module"
	],
	"./mst-cabin/mst-cabin.module": [
		"../../../../../src/app/configuration/mst-cabin/mst-cabin.module.ts",
		"mst-cabin.module"
	],
	"./mst-cash-counter/mst-cash-counter.module": [
		"../../../../../src/app/configuration/mst-cash-counter/mst-cash-counter.module.ts",
		"mst-cash-counter.module"
	],
	"./mst-center-waiver/mst-center-waiver.module": [
		"../../../../../src/app/configuration/mst-center-waiver/mst-center-waiver.module.ts",
		"mst-center-waiver.module"
	],
	"./mst-citizen-id-proof/mst-citizen-id-proof.module": [
		"../../../../../src/app/configuration/mst-citizen-id-proof/mst-citizen-id-proof.module.ts",
		"common",
		"mst-citizen-id-proof.module"
	],
	"./mst-city/mst-city.module": [
		"../../../../../src/app/configuration/mst-city/mst-city.module.ts",
		"common",
		"mst-city.module"
	],
	"./mst-class/mst-class.module": [
		"../../../../../src/app/configuration/mst-class/mst-class.module.ts",
		"mst-class.module"
	],
	"./mst-cluster/mst-cluster.module": [
		"../../../../../src/app/configuration/mst-cluster/mst-cluster.module.ts",
		"common",
		"mst-cluster.module"
	],
	"./mst-company-type/mst-company-type.module": [
		"../../../../../src/app/configuration/mst-company-type/mst-company-type.module.ts",
		"common",
		"mst-company-type.module"
	],
	"./mst-company/mst-company.module": [
		"../../../../../src/app/configuration/mst-company/mst-company.module.ts",
		"common",
		"mst-company.module"
	],
	"./mst-consent/mst-consent.module": [
		"../../../../../src/app/configuration/mst-consent/mst-consent.module.ts",
		"common",
		"mst-consent.module"
	],
	"./mst-country/mst-country.module": [
		"../../../../../src/app/configuration/mst-country/mst-country.module.ts",
		"common",
		"mst-country.module"
	],
	"./mst-cpoe-template/mst-cpoe-template.module": [
		"../../../../../src/app/configuration/mst-cpoe-template/mst-cpoe-template.module.ts",
		"mst-cpoe-template.module"
	],
	"./mst-day/mst-day.module": [
		"../../../../../src/app/configuration/mst-day/mst-day.module.ts",
		"common",
		"mst-day.module"
	],
	"./mst-department-waiver/mst-department-waiver.module": [
		"../../../../../src/app/configuration/mst-department-waiver/mst-department-waiver.module.ts",
		"mst-department-waiver.module"
	],
	"./mst-department/mst-department.module": [
		"../../../../../src/app/configuration/mst-department/mst-department.module.ts",
		"mst-department.module"
	],
	"./mst-designation/mst-designation.module": [
		"../../../../../src/app/configuration/mst-designation/mst-designation.module.ts",
		"common",
		"mst-designation.module"
	],
	"./mst-diet-item/mst-diet-item.module": [
		"../../../../../src/app/configuration/mst-diet-item/mst-diet-item.module.ts",
		"common",
		"mst-diet-item.module"
	],
	"./mst-diet-patient-category/mst-diet-patient-category.module": [
		"../../../../../src/app/configuration/mst-diet-patient-category/mst-diet-patient-category.module.ts",
		"common",
		"mst-diet-patient-category.module"
	],
	"./mst-diet-schedule/mst-diet-schedule.module": [
		"../../../../../src/app/configuration/mst-diet-schedule/mst-diet-schedule.module.ts",
		"common",
		"mst-diet-schedule.module"
	],
	"./mst-diet-unit/mst-diet-unit.module": [
		"../../../../../src/app/configuration/mst-diet-unit/mst-diet-unit.module.ts",
		"common",
		"mst-diet-unit.module"
	],
	"./mst-discharge-special-instruction/mst-discharge-special-instruction.module": [
		"../../../../../src/app/configuration/mst-discharge-special-instruction/mst-discharge-special-instruction.module.ts",
		"mst-discharge-special-instruction.module"
	],
	"./mst-discharge-spinstruction-group/mst-discharge-spinstruction-group.module": [
		"../../../../../src/app/configuration/mst-discharge-spinstruction-group/mst-discharge-spinstruction-group.module.ts",
		"mst-discharge-spinstruction-group.module"
	],
	"./mst-discharge-summary-form/mst-discharge-summary-form.module": [
		"../../../../../src/app/configuration/mst-discharge-summary-form/mst-discharge-summary-form.module.ts",
		"mst-discharge-summary-form.module"
	],
	"./mst-district/mst-district.module": [
		"../../../../../src/app/configuration/mst-district/mst-district.module.ts",
		"common",
		"mst-district.module"
	],
	"./mst-doctor-waiver/mst-doctor-waiver.module": [
		"../../../../../src/app/configuration/mst-doctor-waiver/mst-doctor-waiver.module.ts",
		"mst-doctor-waiver.module"
	],
	"./mst-document-category/mst-document-category.module": [
		"../../../../../src/app/configuration/mst-document-category/mst-document-category.module.ts",
		"common",
		"mst-document-category.module"
	],
	"./mst-dose-dispensing-type/mst-dose-dispensing-type.module": [
		"../../../../../src/app/configuration/mst-dose-dispensing-type/mst-dose-dispensing-type.module.ts",
		"common",
		"mst-dose-dispensing-type.module"
	],
	"./mst-dose-frequency/mst-dose-frequency.module": [
		"../../../../../src/app/configuration/mst-dose-frequency/mst-dose-frequency.module.ts",
		"mst-dose-frequency.module"
	],
	"./mst-drug/mst-drug.module": [
		"../../../../../src/app/configuration/mst-drug/mst-drug.module.ts",
		"common",
		"mst-drug.module"
	],
	"./mst-email-template/mst-email-template.module": [
		"../../../../../src/app/configuration/mst-email-template/mst-email-template.module.ts",
		"mst-email-template.module"
	],
	"./mst-employment-status/mst-employment-status.module": [
		"../../../../../src/app/configuration/mst-employment-status/mst-employment-status.module.ts",
		"common",
		"mst-employment-status.module"
	],
	"./mst-emr-template/mst-emr-template.module": [
		"../../../../../src/app/configuration/mst-emr-template/mst-emr-template.module.ts",
		"common",
		"mst-emr-template.module"
	],
	"./mst-encounter-type/mst-encounter-type.module": [
		"../../../../../src/app/configuration/mst-encounter-type/mst-encounter-type.module.ts",
		"common",
		"mst-encounter-type.module"
	],
	"./mst-equipment/mst-equipment.module": [
		"../../../../../src/app/configuration/mst-equipment/mst-equipment.module.ts",
		"common",
		"mst-equipment.module"
	],
	"./mst-ethnicity/mst-ethnicity.module": [
		"../../../../../src/app/configuration/mst-ethnicity/mst-ethnicity.module.ts",
		"common",
		"mst-ethnicity.module"
	],
	"./mst-expensemanagement/mst-expensemanagement.module": [
		"../../../../../src/app/configuration/mst-expensemanagement/mst-expensemanagement.module.ts",
		"common",
		"mst-expensemanagement.module"
	],
	"./mst-field/mst-field.module": [
		"../../../../../src/app/configuration/mst-field/mst-field.module.ts",
		"mst-field.module"
	],
	"./mst-followup-config/mst-followup-config.module": [
		"../../../../../src/app/configuration/mst-followup-config/mst-followup-config.module.ts",
		"common",
		"mst-followup-config.module"
	],
	"./mst-gender/mst-gender.module": [
		"../../../../../src/app/configuration/mst-gender/mst-gender.module.ts",
		"mst-gender.module"
	],
	"./mst-gp-department/mst-gp-department.module": [
		"../../../../../src/app/configuration/mst-gp-department/mst-gp-department.module.ts",
		"common",
		"mst-gp-department.module"
	],
	"./mst-gp-designation/mst-gp-designation.module": [
		"../../../../../src/app/configuration/mst-gp-designation/mst-gp-designation.module.ts",
		"common",
		"mst-gp-designation.module"
	],
	"./mst-gp-set/mst-gp-set.module": [
		"../../../../../src/app/configuration/mst-gp-set/mst-gp-set.module.ts",
		"common",
		"mst-gp-set.module"
	],
	"./mst-incidentmanagement/mst-incidentmanagement.module": [
		"../../../../../src/app/configuration/mst-incidentmanagement/mst-incidentmanagement.module.ts",
		"common",
		"mst-incidentmanagement.module"
	],
	"./mst-income-category/mst-income-category.module": [
		"../../../../../src/app/configuration/mst-income-category/mst-income-category.module.ts",
		"common",
		"mst-income-category.module"
	],
	"./mst-infectionsystem/mst-infectionsystem.module": [
		"../../../../../src/app/configuration/mst-infectionsystem/mst-infectionsystem.module.ts",
		"mst-infectionsystem.module"
	],
	"./mst-intra-operative-instructions/mst-intra-operative-instructions.module": [
		"../../../../../src/app/configuration/mst-intra-operative-instructions/mst-intra-operative-instructions.module.ts",
		"common",
		"mst-intra-operative-instructions.module"
	],
	"./mst-landmark/mst-landmark.module": [
		"../../../../../src/app/configuration/mst-landmark/mst-landmark.module.ts",
		"common",
		"mst-landmark.module"
	],
	"./mst-language/mst-language.module": [
		"../../../../../src/app/configuration/mst-language/mst-language.module.ts",
		"common",
		"mst-language.module"
	],
	"./mst-marital-status/mst-marital-status.module": [
		"../../../../../src/app/configuration/mst-marital-status/mst-marital-status.module.ts",
		"mst-marital-status.module"
	],
	"./mst-mci/mst-mci.module": [
		"../../../../../src/app/configuration/mst-mci/mst-mci.module.ts",
		"mst-mci.module"
	],
	"./mst-mis-type/mst-mis-type.module": [
		"../../../../../src/app/configuration/mst-mis-type/mst-mis-type.module.ts",
		"mst-mis-type.module"
	],
	"./mst-mlc-checklist/mst-mlc-checklist.module": [
		"../../../../../src/app/configuration/mst-mlc-checklist/mst-mlc-checklist.module.ts",
		"mst-mlc-checklist.module"
	],
	"./mst-mlc-juridiction/mst-mlc-juridiction.module": [
		"../../../../../src/app/configuration/mst-mlc-juridiction/mst-mlc-juridiction.module.ts",
		"mst-mlc-juridiction.module"
	],
	"./mst-mode-of-transfer/mst-mode-of-transfer.module": [
		"../../../../../src/app/configuration/mst-mode-of-transfer/mst-mode-of-transfer.module.ts",
		"common",
		"mst-mode-of-transfer.module"
	],
	"./mst-module/mst-module.module": [
		"../../../../../src/app/configuration/mst-module/mst-module.module.ts",
		"common",
		"mst-module.module"
	],
	"./mst-molecule/mst-molecule.module": [
		"../../../../../src/app/configuration/mst-molecule/mst-molecule.module.ts",
		"common",
		"mst-molecule.module"
	],
	"./mst-nationality/mst-nationality.module": [
		"../../../../../src/app/configuration/mst-nationality/mst-nationality.module.ts",
		"common",
		"mst-nationality.module"
	],
	"./mst-non-drug-allergy/mst-non-drug-allergy.module": [
		"../../../../../src/app/configuration/mst-non-drug-allergy/mst-non-drug-allergy.module.ts",
		"mst-non-drug-allergy.module"
	],
	"./mst-notification-config/mst-notification-config.module": [
		"../../../../../src/app/configuration/mst-notification-config/mst-notification-config.module.ts",
		"mst-notification-config.module"
	],
	"./mst-occupation/mst-occupation.module": [
		"../../../../../src/app/configuration/mst-occupation/mst-occupation.module.ts",
		"common",
		"mst-occupation.module"
	],
	"./mst-operation-result/mst-operation-result.module": [
		"../../../../../src/app/configuration/mst-operation-result/mst-operation-result.module.ts",
		"mst-operation-result.module"
	],
	"./mst-operation-status/mst-operation-status.module": [
		"../../../../../src/app/configuration/mst-operation-status/mst-operation-status.module.ts",
		"common",
		"mst-operation-status.module"
	],
	"./mst-operation-theatre-table/mst-operation-theatre-table.module": [
		"../../../../../src/app/configuration/mst-operation-theatre-table/mst-operation-theatre-table.module.ts",
		"common",
		"mst-operation-theatre-table.module"
	],
	"./mst-operation-theatre/mst-operation-theatre.module": [
		"../../../../../src/app/configuration/mst-operation-theatre/mst-operation-theatre.module.ts",
		"common",
		"mst-operation-theatre.module"
	],
	"./mst-org/mst-org.module": [
		"../../../../../src/app/configuration/mst-org/mst-org.module.ts",
		"common",
		"mst-org.module"
	],
	"./mst-patient-source/mst-patient-source.module": [
		"../../../../../src/app/configuration/mst-patient-source/mst-patient-source.module.ts",
		"common",
		"mst-patient-source.module"
	],
	"./mst-patient-type/mst-patient-type.module": [
		"../../../../../src/app/configuration/mst-patient-type/mst-patient-type.module.ts",
		"common",
		"mst-patient-type.module"
	],
	"./mst-patient/mst-patient.module": [
		"../../../../../src/app/configuration/mst-patient/mst-patient.module.ts",
		"common",
		"mst-patient.module"
	],
	"./mst-payment-mode/mst-payment-mode.module": [
		"../../../../../src/app/configuration/mst-payment-mode/mst-payment-mode.module.ts",
		"common",
		"mst-payment-mode.module"
	],
	"./mst-police-station/mst-police-station.module": [
		"../../../../../src/app/configuration/mst-police-station/mst-police-station.module.ts",
		"common",
		"mst-police-station.module"
	],
	"./mst-post-operative-instructions/mst-post-operative-instructions.module": [
		"../../../../../src/app/configuration/mst-post-operative-instructions/mst-post-operative-instructions.module.ts",
		"common",
		"mst-post-operative-instructions.module"
	],
	"./mst-pre-operative-instructions/mst-pre-operative-instructions.module": [
		"../../../../../src/app/configuration/mst-pre-operative-instructions/mst-pre-operative-instructions.module.ts",
		"common",
		"mst-pre-operative-instructions.module"
	],
	"./mst-priority/mst-priority.module": [
		"../../../../../src/app/configuration/mst-priority/mst-priority.module.ts",
		"common",
		"mst-priority.module"
	],
	"./mst-procedure-category/mst-procedure-category.module": [
		"../../../../../src/app/configuration/mst-procedure-category/mst-procedure-category.module.ts",
		"common",
		"mst-procedure-category.module"
	],
	"./mst-procedure-checklist/mst-procedure-checklist.module": [
		"../../../../../src/app/configuration/mst-procedure-checklist/mst-procedure-checklist.module.ts",
		"common",
		"mst-procedure-checklist.module"
	],
	"./mst-procedure-subcategory/mst-procedure-subcategory.module": [
		"../../../../../src/app/configuration/mst-procedure-subcategory/mst-procedure-subcategory.module.ts",
		"common",
		"mst-procedure-subcategory.module"
	],
	"./mst-procedure-type/mst-procedure-type.module": [
		"../../../../../src/app/configuration/mst-procedure-type/mst-procedure-type.module.ts",
		"common",
		"mst-procedure-type.module"
	],
	"./mst-procedure/mst-procedure.module": [
		"../../../../../src/app/configuration/mst-procedure/mst-procedure.module.ts",
		"common",
		"mst-procedure.module"
	],
	"./mst-race/mst-race.module": [
		"../../../../../src/app/configuration/mst-race/mst-race.module.ts",
		"common",
		"mst-race.module"
	],
	"./mst-referring-entity-type/mst-referring-entity-type.module": [
		"../../../../../src/app/configuration/mst-referring-entity-type/mst-referring-entity-type.module.ts",
		"common",
		"mst-referring-entity-type.module"
	],
	"./mst-referring-entity/mst-referring-entity.module": [
		"../../../../../src/app/configuration/mst-referring-entity/mst-referring-entity.module.ts",
		"common",
		"mst-referring-entity.module"
	],
	"./mst-relation/mst-relation.module": [
		"../../../../../src/app/configuration/mst-relation/mst-relation.module.ts",
		"common",
		"mst-relation.module"
	],
	"./mst-role/mst-role.module": [
		"../../../../../src/app/configuration/mst-role/mst-role.module.ts",
		"common",
		"mst-role.module"
	],
	"./mst-route/mst-route.module": [
		"../../../../../src/app/configuration/mst-route/mst-route.module.ts",
		"mst-route.module"
	],
	"./mst-schedule-detail/mst-schedule-detail.module": [
		"../../../../../src/app/configuration/mst-schedule-detail/mst-schedule-detail.module.ts",
		"common",
		"mst-schedule-detail.module"
	],
	"./mst-schedule/mst-schedule.module": [
		"../../../../../src/app/configuration/mst-schedule/mst-schedule.module.ts",
		"common",
		"mst-schedule.module"
	],
	"./mst-section/mst-section.module": [
		"../../../../../src/app/configuration/mst-section/mst-section.module.ts",
		"mst-section.module"
	],
	"./mst-set/mst-set.module": [
		"../../../../../src/app/configuration/mst-set/mst-set.module.ts",
		"mst-set.module"
	],
	"./mst-shift/mst-shift.module": [
		"../../../../../src/app/configuration/mst-shift/mst-shift.module.ts",
		"mst-shift.module"
	],
	"./mst-sms-template/mst-sms-template.module": [
		"../../../../../src/app/configuration/mst-sms-template/mst-sms-template.module.ts",
		"mst-sms-template.module"
	],
	"./mst-social-status/mst-social-status.module": [
		"../../../../../src/app/configuration/mst-social-status/mst-social-status.module.ts",
		"common",
		"mst-social-status.module"
	],
	"./mst-speciality/mst-speciality.module": [
		"../../../../../src/app/configuration/mst-speciality/mst-speciality.module.ts",
		"mst-speciality.module"
	],
	"./mst-sponsor-combination/mst-sponsor-combination.module": [
		"../../../../../src/app/configuration/mst-sponsor-combination/mst-sponsor-combination.module.ts",
		"common",
		"mst-sponsor-combination.module"
	],
	"./mst-staff/mst-staff.module": [
		"../../../../../src/app/configuration/mst-staff/mst-staff.module.ts",
		"common",
		"mst-staff.module"
	],
	"./mst-state/mst-state.module": [
		"../../../../../src/app/configuration/mst-state/mst-state.module.ts",
		"common",
		"mst-state.module"
	],
	"./mst-strength-unit/mst-strength-unit.module": [
		"../../../../../src/app/configuration/mst-strength-unit/mst-strength-unit.module.ts",
		"common",
		"mst-strength-unit.module"
	],
	"./mst-sub-department/mst-sub-department.module": [
		"../../../../../src/app/configuration/mst-sub-department/mst-sub-department.module.ts",
		"mst-sub-department.module"
	],
	"./mst-super-speciality/mst-super-speciality.module": [
		"../../../../../src/app/configuration/mst-super-speciality/mst-super-speciality.module.ts",
		"common",
		"mst-super-speciality.module"
	],
	"./mst-tab/mst-tab.module": [
		"../../../../../src/app/configuration/mst-tab/mst-tab.module.ts",
		"mst-tab.module"
	],
	"./mst-taluka/mst-taluka.module": [
		"../../../../../src/app/configuration/mst-taluka/mst-taluka.module.ts",
		"common",
		"mst-taluka.module"
	],
	"./mst-timeunit/mst-timeunit.module": [
		"../../../../../src/app/configuration/mst-timeunit/mst-timeunit.module.ts",
		"mst-timeunit.module"
	],
	"./mst-title/mst-title.module": [
		"../../../../../src/app/configuration/mst-title/mst-title.module.ts",
		"common",
		"mst-title.module"
	],
	"./mst-triage/mst-triage.module": [
		"../../../../../src/app/configuration/mst-triage/mst-triage.module.ts",
		"mst-triage.module"
	],
	"./mst-unit-measurment/mst-unit-measurment.module": [
		"../../../../../src/app/configuration/mst-unit-measurment/mst-unit-measurment.module.ts",
		"mst-unit-measurment.module"
	],
	"./mst-unit/mst-unit.module": [
		"../../../../../src/app/configuration/mst-unit/mst-unit.module.ts",
		"common",
		"mst-unit.module"
	],
	"./mst-user-type/mst-user-type.module": [
		"../../../../../src/app/configuration/mst-user-type/mst-user-type.module.ts",
		"mst-user-type.module"
	],
	"./mst-user/mst-user.module": [
		"../../../../../src/app/configuration/mst-user/mst-user.module.ts",
		"common",
		"mst-user.module"
	],
	"./mst-vacc-auto-chart/mst-vacc-auto-chart.module": [
		"../../../../../src/app/configuration/mst-vacc-auto-chart/mst-vacc-auto-chart.module.ts",
		"common",
		"mst-vacc-auto-chart.module"
	],
	"./mst-vacc-patient-category/mst-vacc-patient-category.module": [
		"../../../../../src/app/configuration/mst-vacc-patient-category/mst-vacc-patient-category.module.ts",
		"common",
		"mst-vacc-patient-category.module"
	],
	"./mst-vacc-site/mst-vacc-site.module": [
		"../../../../../src/app/configuration/mst-vacc-site/mst-vacc-site.module.ts",
		"mst-vacc-site.module"
	],
	"./mst-visit-service/mst-visit-service.module": [
		"../../../../../src/app/configuration/mst-visit-service/mst-visit-service.module.ts",
		"common",
		"mst-visit-service.module"
	],
	"./mst-visit-type/mst-visit-type.module": [
		"../../../../../src/app/configuration/mst-visit-type/mst-visit-type.module.ts",
		"common",
		"mst-visit-type.module"
	],
	"./mst-visit/mst-visit.module": [
		"../../../../../src/app/configuration/mst-visit/mst-visit.module.ts",
		"common",
		"mst-visit.module"
	],
	"./non-vacant-bed/non-vacant-bed.module": [
		"../../../../../src/app/ipd/bed-management/under-maintenance/non-vacant-bed/non-vacant-bed.module.ts",
		"common",
		"non-vacant-bed.module"
	],
	"./nst-method-delivery/nst-method-delivery.module": [
		"../../../../../src/app/configuration/nst-method-delivery/nst-method-delivery.module.ts",
		"common",
		"nst-method-delivery.module"
	],
	"./nst-nursing-station-defination/nst-nursing-station-defination.module": [
		"../../../../../src/app/configuration/nst-nursing-station-defination/nst-nursing-station-defination.module.ts",
		"common",
		"nst-nursing-station-defination.module"
	],
	"./oncology-emr/oncology-emr.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/oncology-emr/oncology-emr.module.ts",
		"oncology-emr.module"
	],
	"./opd-tally/opd-tally.module": [
		"../../../../../src/app/mis/opd-tally/opd-tally.module.ts",
		"opd-tally.module"
	],
	"./ot-details-old/ot-details-old.module": [
		"../../../../../src/app/operation-theater/ot-schedule/ot-details-old/ot-details-old.module.ts",
		"common",
		"ot-details-old.module"
	],
	"./ot-details/ot-details.module": [
		"../../../../../src/app/operation-theater/ot-details/ot-details.module.ts",
		"common",
		"ot-details.module"
	],
	"./pathalogy/pathalogy.module": [
		"../../../../../src/app/mis/mis-investigation/pathalogy/pathalogy.module.ts",
		"common",
		"pathalogy.module"
	],
	"./patient-about/patient-about.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-about/patient-about.module.ts",
		"patient-about.module"
	],
	"./patient-chart-parent/patient-chart-parent.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-chart-parent.module.ts",
		"common",
		"patient-chart-parent.module"
	],
	"./patient-diagnostic-view/patient-diagnostic-view.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-diagnostic-view/patient-diagnostic-view.module.ts",
		"common",
		"patient-diagnostic-view.module"
	],
	"./patient-dietplan/patient-dietchart/patient-dietchart.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-dietplan/patient-dietchart/patient-dietchart.module.ts",
		"patient-dietchart.module"
	],
	"./patient-emr/patient-emr.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-emr/patient-emr.module.ts",
		"common",
		"patient-emr.module"
	],
	"./patient-registration-list/patient-registration-list.module": [
		"../../../../../src/app/opd/patient-registration-list/patient-registration-list.module.ts",
		"common",
		"patient-registration-list.module"
	],
	"./patient-registration/patient-registration.module": [
		"../../../../../src/app/opd/patient-registration/patient-registration.module.ts",
		"common",
		"patient-registration.module"
	],
	"./patient-timeline/patient-timeline.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-timeline/patient-timeline.module.ts",
		"patient-timeline.module"
	],
	"./patient-upload/patient-upload.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-upload/patient-upload.module.ts",
		"common",
		"patient-upload.module"
	],
	"./patient_vaccines/immunization-vaccination.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient_vaccines/immunization-vaccination.module.ts",
		"immunization-vaccination.module"
	],
	"./pharamacy-record-dashboard/pharamacy-record-dashboard.module": [
		"../../../../../src/app/ipd/patient-emr-dashboard/pharamacy-record-dashboard/pharamacy-record-dashboard.module.ts",
		"pharamacy-record-dashboard.module"
	],
	"./portal-appointment-list/portal-appointment-list.module": [
		"../../../../../src/app/opd/portal-appointment-list/portal-appointment-list.module.ts",
		"common",
		"portal-appointment-list.module"
	],
	"./post-operative-instruction-details/post-operative-instruction-details.module": [
		"../../../../../src/app/operation-theater/ot-schedule/post-operative-instruction-details/post-operative-instruction-details.module.ts",
		"common",
		"post-operative-instruction-details.module"
	],
	"./pre-operative-instruction-details/pre-operative-instruction-details.module": [
		"../../../../../src/app/operation-theater/ot-schedule/pre-operative-instruction-details/pre-operative-instruction-details.module.ts",
		"common",
		"pre-operative-instruction-details.module"
	],
	"./procedure-details/procedure-details.module": [
		"../../../../../src/app/operation-theater/ot-schedule/procedure-details/procedure-details.module.ts",
		"common",
		"procedure-details.module"
	],
	"./quality-indicators/quality-indicators.module": [
		"../../../../../src/app/mis/quality-indicators/quality-indicators.module.ts",
		"quality-indicators.module"
	],
	"./queue-management-by-dept/queue-management.module": [
		"../../../../../src/app/opd/queue-management-by-dept/queue-management.module.ts",
		"common",
		"queue-management.module"
	],
	"./queue-management/queue-management.module": [
		"../../../../../src/app/opd/queue-management/queue-management.module.ts",
		"common",
		"queue-management.module.0"
	],
	"./radiology/radiology.module": [
		"../../../../../src/app/mis/mis-investigation/radiology/radiology.module.ts",
		"radiology.module"
	],
	"./realease-bed-maintenance/realease-bed-maintenance.module": [
		"../../../../../src/app/ipd/bed-management/under-maintenance/realease-bed-maintenance/realease-bed-maintenance.module.ts",
		"common",
		"realease-bed-maintenance.module"
	],
	"./reg-patient-visit/reg-patient-visit.module": [
		"../../../../../src/app/opd/reg-patient-visit/reg-patient-visit.module.ts",
		"common",
		"reg-patient-visit.module"
	],
	"./registered-patient/registered-patient.module": [
		"../../../../../src/app/opd/registered-patient/registered-patient.module.ts",
		"common",
		"registered-patient.module"
	],
	"./rpath-test-parameter/rpath-test-parameter.module": [
		"../../../../../src/app/configuration/mpath-test/rpath-test-parameter/rpath-test-parameter.module.ts",
		"common",
		"rpath-test-parameter.module"
	],
	"./service-details/service-details.module": [
		"../../../../../src/app/operation-theater/ot-schedule/service-details/service-details.module.ts",
		"common",
		"service-details.module"
	],
	"./staff-details/staff-details.module": [
		"../../../../../src/app/operation-theater/ot-schedule/staff-details/staff-details.module.ts",
		"staff-details.module"
	],
	"./supplier-portal/supplier-portal.module": [
		"../../../../../src/app/inventory/supplier-portal/supplier-portal.module.ts",
		"supplier-portal.module"
	],
	"./tbill-agency-rate/tbill-agency-rate.module": [
		"../../../../../src/app/configuration/tbill-agency-rate/tbill-agency-rate.module.ts",
		"common",
		"tbill-agency-rate.module"
	],
	"./tbill-plan-item/tbill-plan-item.module": [
		"../../../../../src/app/configuration/tbill-plan-item/tbill-plan-item.module.ts",
		"common",
		"tbill-plan-item.module"
	],
	"./tbill-plan-service/tbill-plan-service.module": [
		"../../../../../src/app/configuration/tbill-plan-service/tbill-plan-service.module.ts",
		"common",
		"tbill-plan-service.module"
	],
	"./tbill-plan-uncovered-drug/tbill-plan-uncovered-drug.module": [
		"../../../../../src/app/configuration/tbill-plan-uncovered-drug/tbill-plan-uncovered-drug.module.ts",
		"common",
		"tbill-plan-uncovered-drug.module"
	],
	"./tbill-plan-uncovered-service/tbill-plan-uncovered-service.module": [
		"../../../../../src/app/configuration/tbill-plan-uncovered-service/tbill-plan-uncovered-service.module.ts",
		"common",
		"tbill-plan-uncovered-service.module"
	],
	"./temr-clinical-form/temr-clinical-form.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/temr-clinical-form/temr-clinical-form.module.ts",
		"common",
		"temr-clinical-form.module"
	],
	"./temr-doctors-advice/temr-doctors-advice.module": [
		"../../../../../src/app/configuration/temr-doctors-advice/temr-doctors-advice.module.ts",
		"temr-doctors-advice.module"
	],
	"./temr-doctors-order/temr-doctors-order.module": [
		"../../../../../src/app/configuration/temr-doctors-order/temr-doctors-order.module.ts",
		"temr-doctors-order.module"
	],
	"./temr-document-upload/temr-document-upload.module": [
		"../../../../../src/app/configuration/temr-document-upload/temr-document-upload.module.ts",
		"common",
		"temr-document-upload.module"
	],
	"./temr-timeline/temr-timeline.module": [
		"../../../../../src/app/configuration/temr-timeline/temr-timeline.module.ts",
		"temr-timeline.module"
	],
	"./temr-visit-allergy/temr-visit-allergy.module": [
		"../../../../../src/app/configuration/temr-visit-allergy/temr-visit-allergy.module.ts",
		"common",
		"temr-visit-allergy.module"
	],
	"./temr-visit-chief-complaint/temr-visit-chief-complaint.module": [
		"../../../../../src/app/configuration/temr-visit-chief-complaint/temr-visit-chief-complaint.module.ts",
		"common",
		"temr-visit-chief-complaint.module"
	],
	"./temr-visit-diagnosis/temr-visit-diagnosis.module": [
		"../../../../../src/app/configuration/temr-visit-diagnosis/temr-visit-diagnosis.module.ts",
		"temr-visit-diagnosis.module"
	],
	"./temr-visit-doctors-note/temr-visit-doctors-note.module": [
		"../../../../../src/app/configuration/temr-visit-doctors-note/temr-visit-doctors-note.module.ts",
		"temr-visit-doctors-note.module"
	],
	"./temr-visit-history/temr-visit-history.module": [
		"../../../../../src/app/configuration/temr-visit-history/temr-visit-history.module.ts",
		"common",
		"temr-visit-history.module"
	],
	"./temr-visit-non-drug-allergy/temr-visit-non-drug-allergy.module": [
		"../../../../../src/app/configuration/temr-visit-non-drug-allergy/temr-visit-non-drug-allergy.module.ts",
		"temr-visit-non-drug-allergy.module"
	],
	"./temr-visit-symptom/temr-visit-symptom.module": [
		"../../../../../src/app/configuration/temr-visit-symptom/temr-visit-symptom.module.ts",
		"common",
		"temr-visit-symptom.module"
	],
	"./temr-vital/temr-vital.module": [
		"../../../../../src/app/configuration/temr-vital/temr-vital.module.ts",
		"temr-vital.module"
	],
	"./tinv-ipd-pharmacy-sale/tinv-ipd-pharmacy-sale.module": [
		"../../../../../src/app/inventory/tinv-ipd-pharmacy-sale/tinv-ipd-pharmacy-sale.module.ts",
		"common",
		"tinv-ipd-pharmacy-sale.module"
	],
	"./tinv-issue-clinic/tinv-issue-clinic.module": [
		"../../../../../src/app/inventory/tinv-issue-clinic/tinv-issue-clinic.module.ts",
		"common",
		"tinv-issue-clinic.module"
	],
	"./tinv-item-sales-return/tinv-item-sales-return.module": [
		"../../../../../src/app/inventory/tinv-item-sales-return/tinv-item-sales-return.module.ts",
		"common",
		"tinv-item-sales-return.module"
	],
	"./tinv-item-stock-adjustment/tinv-item-stock-adjustment.module": [
		"../../../../../src/app/inventory/tinv-item-stock-adjustment/tinv-item-stock-adjustment.module.ts",
		"common",
		"tinv-item-stock-adjustment.module"
	],
	"./tinv-nursing-indent/tinv-nursing-indent.module": [
		"../../../../../src/app/inventory/tinv-nursing-indent/tinv-nursing-indent.module.ts",
		"common",
		"tinv-nursing-indent.module"
	],
	"./tinv-opening-balance/tinv-opening-balance.module": [
		"../../../../../src/app/inventory/tinv-opening-balance/tinv-opening-balance.module.ts",
		"common",
		"tinv-opening-balance.module"
	],
	"./tinv-pharmacy-bill-edit/tinv-pharmacy-bill-edit.module": [
		"../../../../../src/app/inventory/tinv-pharmacy-bill-edit/tinv-pharmacy-bill-edit.module.ts",
		"tinv-pharmacy-bill-edit.module"
	],
	"./tinv-pharmacy-sale-list/tinv-pharmacy-sale-list.module": [
		"../../../../../src/app/inventory/tinv-pharmacy-sale-list/tinv-pharmacy-sale-list.module.ts",
		"common",
		"tinv-pharmacy-sale-list.module"
	],
	"./tinv-pharmacy-sale/tinv-pharmacy-sale.module": [
		"../../../../../src/app/inventory/tinv-pharmacy-sale/tinv-pharmacy-sale.module.ts",
		"common",
		"tinv-pharmacy-sale.module"
	],
	"./tinv-purchase-goods-received-note/tinv-purchase-goods-received-note.module": [
		"../../../../../src/app/inventory/tinv-purchase-goods-received-note/tinv-purchase-goods-received-note.module.ts",
		"common",
		"tinv-purchase-goods-received-note.module"
	],
	"./tinv-purchase-goods-return-note/tinv-purchase-goods-return-note.module": [
		"../../../../../src/app/inventory/tinv-purchase-goods-return-note/tinv-purchase-goods-return-note.module.ts",
		"common",
		"tinv-purchase-goods-return-note.module"
	],
	"./tinv-purchase-item-enquiry/tinv-purchase-item-enquiry.module": [
		"../../../../../src/app/inventory/tinv-purchase-item-enquiry/tinv-purchase-item-enquiry.module.ts",
		"common",
		"tinv-purchase-item-enquiry.module"
	],
	"./tinv-purchase-pharmacy-bill-settlement/tinv-purchase-pharmacy-bill-settlement.module": [
		"../../../../../src/app/inventory/tinv-purchase-pharmacy-bill-settlement/tinv-purchase-pharmacy-bill-settlement.module.ts",
		"common",
		"tinv-purchase-pharmacy-bill-settlement.module"
	],
	"./tinv-purchase-purchase-order/tinv-purchase-purchase-order.module": [
		"../../../../../src/app/inventory/tinv-purchase-purchase-order/tinv-purchase-purchase-order.module.ts",
		"common",
		"tinv-purchase-purchase-order.module"
	],
	"./tinv-purchase-quotation/tinv-purchase-quotation.module": [
		"../../../../../src/app/inventory/tinv-purchase-quotation/tinv-purchase-quotation.module.ts",
		"common",
		"tinv-purchase-quotation.module"
	],
	"./tinv-receive-issue/tinv-receive-issue.module": [
		"../../../../../src/app/inventory/tinv-receive-issue/tinv-receive-issue.module.ts",
		"common",
		"tinv-receive-issue.module"
	],
	"./tinv-return-issue/tinv-return-issue.module": [
		"../../../../../src/app/inventory/tinv-return-issue/tinv-return-issue.module.ts",
		"common",
		"tinv-return-issue.module"
	],
	"./tinv-scrape-sale/tinv-scrape-sale.module": [
		"../../../../../src/app/inventory/tinv-scrape-sale/tinv-scrape-sale.module.ts",
		"common",
		"tinv-scrape-sale.module"
	],
	"./tinv-stock-cunsumption/tinv-stock-cunsumption.module": [
		"../../../../../src/app/inventory/tinv-stock-cunsumption/tinv-stock-cunsumption.module.ts",
		"common",
		"tinv-stock-cunsumption.module"
	],
	"./tinv-store-indent/tinv-store-indent.module": [
		"../../../../../src/app/inventory/tinv-store-indent/tinv-store-indent.module.ts",
		"common",
		"tinv-store-indent.module"
	],
	"./trn-appointment/trn-appointment.module": [
		"../../../../../src/app/opd/trn-appointment/trn-appointment.module.ts",
		"common",
		"trn-appointment.module"
	],
	"./trn-blood-bank/trn-blood-bank.module": [
		"../../../../../src/app/configuration/trn-blood-bank/trn-blood-bank.module.ts",
		"trn-blood-bank.module"
	],
	"./trn-blood-stock/trn-blood-stock.module": [
		"../../../../../src/app/configuration/trn-blood-stock/trn-blood-stock.module.ts",
		"trn-blood-stock.module"
	],
	"./trn-doctor-schedule-detail/trn-doctor-schedule-detail.module": [
		"../../../../../src/app/configuration/trn-doctor-schedule-detail/trn-doctor-schedule-detail.module.ts",
		"common",
		"trn-doctor-schedule-detail.module"
	],
	"./trn-drug-molecule/trn-drug-molecule.module": [
		"../../../../../src/app/configuration/trn-drug-molecule/trn-drug-molecule.module.ts",
		"common",
		"trn-drug-molecule.module"
	],
	"./trn-issue-management/trn-issue-management.module": [
		"../../../../../src/app/configuration/trn-issue-management/trn-issue-management.module.ts",
		"trn-issue-management.module"
	],
	"./trn-opd-ipd/trn-opd-ipd.module": [
		"../../../../../src/app/opd/trn-opd-ipd/trn-opd-ipd.module.ts",
		"common",
		"trn-opd-ipd.module"
	],
	"./trn-sponsor-combination/trn-sponsor-combination.module": [
		"../../../../../src/app/configuration/trn-sponsor-combination/trn-sponsor-combination.module.ts",
		"common",
		"trn-sponsor-combination.module"
	],
	"./under-maintenance/under-maintenance.module": [
		"../../../../../src/app/ipd/bed-management/under-maintenance/under-maintenance.module.ts",
		"under-maintenance.module"
	],
	"./user-audit/user-audit.module": [
		"../../../../../src/app/mis/user-audit/user-audit.module.ts",
		"user-audit.module"
	],
	"./user-data-module/user-data.module": [
		"../../../../../src/app/configuration/user-data-module/user-data.module.ts",
		"user-data.module"
	],
	"./vacant-bed/vacant-bed.module": [
		"../../../../../src/app/ipd/bed-management/under-maintenance/vacant-bed/vacant-bed.module.ts"
	],
	"./vd-iochart/vd-iochart.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-emr/emr-vitaldetails/vd-iochart/vd-iochart.module.ts",
		"vd-iochart.module"
	],
	"./vd-vitaldetails/vd-vitaldetails.module": [
		"../../../../../src/app/patient-chart/patient-chart-parent/patient-emr/emr-vitaldetails/vd-vitaldetails/vd-vitaldetails.module.ts",
		"vd-vitaldetails.module"
	],
	"app/billing/advance/advance.module": [
		"../../../../../src/app/billing/advance/advance.module.ts",
		"common",
		"advance.module"
	],
	"app/billing/bill-list/bill-list.module": [
		"../../../../../src/app/billing/bill-list/bill-list.module.ts",
		"common",
		"bill-list.module"
	],
	"app/billing/bill-refund/bill-refund.module": [
		"../../../../../src/app/billing/bill-refund/bill-refund.module.ts",
		"common",
		"bill-refund.module"
	],
	"app/billing/bill-settlement-list/bill-settlement-list.module": [
		"../../../../../src/app/billing/bill-settlement-list/bill-settlement-list.module.ts",
		"common",
		"bill-settlement-list.module"
	],
	"app/billing/cancel-bill-list/cancel-bill-list.module": [
		"../../../../../src/app/billing/cancel-bill-list/cancel-bill-list.module.ts",
		"cancel-bill-list.module"
	],
	"app/billing/company-settelment/company-settelment.module": [
		"../../../../../src/app/billing/company-settelment/company-settelment.module.ts",
		"company-settelment.module"
	],
	"app/billing/credit-bill-settlement/credit-bill-settlement.module": [
		"../../../../../src/app/billing/credit-bill-settlement/credit-bill-settlement.module.ts",
		"common",
		"credit-bill-settlement.module"
	],
	"app/billing/doctor-share-billing/doctor-share-billing.module": [
		"../../../../../src/app/billing/doctor-share-billing/doctor-share-billing.module.ts",
		"common",
		"doctor-share-billing.module"
	],
	"app/billing/doctor-share/doctor-share.module": [
		"../../../../../src/app/billing/doctor-share/doctor-share.module.ts",
		"common",
		"doctor-share.module"
	],
	"app/billing/emr-tbill-bill/emr-tbill-bill.module": [
		"../../../../../src/app/billing/emr-tbill-bill/emr-tbill-bill.module.ts",
		"common",
		"emr-tbill-bill.module"
	],
	"app/billing/ipd-bill-reconciliation/ipd-bill-reconciliation.module": [
		"../../../../../src/app/billing/ipd-bill-reconciliation/ipd-bill-reconciliation.module.ts",
		"common",
		"ipd-bill-reconciliation.module"
	],
	"app/billing/ipd-bill-settlement/ipd-bill-settlement.module": [
		"../../../../../src/app/billing/ipd-bill-settlement/ipd-bill-settlement.module.ts",
		"common",
		"ipd-bill-settlement.module"
	],
	"app/billing/ipd-bill/ipd-bill.module": [
		"../../../../../src/app/billing/ipd-bill/ipd-bill.module.ts",
		"common",
		"ipd-bill.module"
	],
	"app/billing/ipd-charges/ipd-charges.module": [
		"../../../../../src/app/billing/ipd-charges/ipd-charges.module.ts",
		"common",
		"ipd-charges.module"
	],
	"app/billing/tbill-bill/tbill-bill.module": [
		"../../../../../src/app/billing/tbill-bill/tbill-bill.module.ts",
		"common",
		"tbill-bill.module"
	],
	"app/billing/tbill-view-bill/tbill-view-bill.module": [
		"../../../../../src/app/billing/tbill-view-bill/tbill-view-bill.module.ts",
		"tbill-view-bill.module"
	],
	"app/billing/view-consolidated-bill/view-consolidated-bill.module": [
		"../../../../../src/app/billing/view-consolidated-bill/view-consolidated-bill.module.ts",
		"common",
		"view-consolidated-bill.module"
	],
	"app/billing/view-final-bill/view-final-bill.module": [
		"../../../../../src/app/billing/view-final-bill/view-final-bill.module.ts",
		"common",
		"view-final-bill.module"
	],
	"app/configuration/trn-admission/trn-admission.module": [
		"../../../../../src/app/configuration/trn-admission/trn-admission.module.ts",
		"common",
		"trn-admission.module"
	],
	"app/emergency/emg-consent-form/emg-consent-form.module": [
		"../../../../../src/app/emergency/emg-consent-form/emg-consent-form.module.ts",
		"common",
		"emg-consent-form.module"
	],
	"app/emergency/emg-nursing-assessment-form/emg-nursing-assessment-form.module": [
		"../../../../../src/app/emergency/emg-nursing-assessment-form/emg-nursing-assessment-form.module.ts",
		"common",
		"emg-nursing-assessment-form.module"
	],
	"app/emergency/emg-patient-cancel-list/emg-patient-cancel-list.module": [
		"../../../../../src/app/emergency/emg-patient-cancel-list/emg-patient-cancel-list.module.ts",
		"common",
		"emg-patient-cancel-list.module"
	],
	"app/emergency/emg-patient-discharge-list/emg-patient-discharge-list.module": [
		"../../../../../src/app/emergency/emg-patient-discharge-list/emg-patient-discharge-list.module.ts",
		"common",
		"emg-patient-discharge-list.module"
	],
	"app/emergency/emg-patient-list/emg-patient-list.module": [
		"../../../../../src/app/emergency/emg-patient-list/emg-patient-list.module.ts",
		"common",
		"emg-patient-list.module"
	],
	"app/emergency/emg-triage-form/emg-triage-form.module": [
		"../../../../../src/app/emergency/emg-triage-form/emg-triage-form.module.ts",
		"common",
		"emg-triage-form.module"
	],
	"app/emrsidebar/emr-patient-list/emr-patient-list.module": [
		"../../../../../src/app/emrsidebar/emr-patient-list/emr-patient-list.module.ts",
		"emr-patient-list.module"
	],
	"app/emrsidebar/emr-patient-queue/emr-patient-queue.module": [
		"../../../../../src/app/emrsidebar/emr-patient-queue/emr-patient-queue.module.ts",
		"common",
		"emr-patient-queue.module"
	],
	"app/emrsidebar/patient-registration-search/patient-registration-search.module": [
		"../../../../../src/app/emrsidebar/patient-registration-search/patient-registration-search.module.ts",
		"common",
		"patient-registration-search.module"
	],
	"app/investigation/pathology/lab_item_consumtion/lab_item_consumtion.module": [
		"../../../../../src/app/investigation/pathology/lab_item_consumtion/lab_item_consumtion.module.ts",
		"lab_item_consumtion.module"
	],
	"app/investigation/pathology/lab_order_list/lab_order_list.module": [
		"../../../../../src/app/investigation/pathology/lab_order_list/lab_order_list.module.ts",
		"common",
		"lab_order_list.module"
	],
	"app/investigation/pathology/lab_report/lab_reports.module": [
		"../../../../../src/app/investigation/pathology/lab_report/lab_reports.module.ts",
		"common",
		"lab_reports.module"
	],
	"app/investigation/pathology/mpath-outsource-profit/mpath-outsource-profit.module": [
		"../../../../../src/app/investigation/pathology/mpath-outsource-profit/mpath-outsource-profit.module.ts",
		"common",
		"mpath-outsource-profit.module"
	],
	"app/investigation/pathology/pathology.module": [
		"../../../../../src/app/investigation/pathology/pathology.module.ts",
		"pathology.module"
	],
	"app/investigation/pathology/tata_anatomy_lab_report/tata_anatomy_lab_reports.module": [
		"../../../../../src/app/investigation/pathology/tata_anatomy_lab_report/tata_anatomy_lab_reports.module.ts",
		"common",
		"tata_anatomy_lab_reports.module"
	],
	"app/investigation/pathology/tata_biology_lab_report/tata_biology_lab_reports.module": [
		"../../../../../src/app/investigation/pathology/tata_biology_lab_report/tata_biology_lab_reports.module.ts",
		"tata_biology_lab_reports.module"
	],
	"app/investigation/radiology/create-report/create-report.module": [
		"../../../../../src/app/investigation/radiology/create-report/create-report.module.ts",
		"common",
		"create-report.module"
	],
	"app/investigation/radiology/lab-order/lab-order.module": [
		"../../../../../src/app/investigation/radiology/lab-order/lab-order.module.ts",
		"common",
		"lab-order.module"
	],
	"app/investigation/radiology/radiology.module": [
		"../../../../../src/app/investigation/radiology/radiology.module.ts",
		"common",
		"radiology.module.0"
	],
	"app/ipd/admission-details/admission-details.module": [
		"../../../../../src/app/ipd/admission-details/admission-details.module.ts",
		"common",
		"admission-details.module"
	],
	"app/ipd/admission-list/admission-list.module": [
		"../../../../../src/app/ipd/admission-list/admission-list.module.ts",
		"admission-list.module"
	],
	"app/ipd/admission-request/admission-request.module": [
		"../../../../../src/app/ipd/admission-request/admission-request.module.ts",
		"common",
		"admission-request.module"
	],
	"app/ipd/admission-request/new-admission-request/new-admission-request.module": [
		"../../../../../src/app/ipd/admission-request/new-admission-request/new-admission-request.module.ts",
		"common"
	],
	"app/ipd/admission/admission.module": [
		"../../../../../src/app/ipd/admission/admission.module.ts",
		"common",
		"admission.module"
	],
	"app/ipd/bed-management/bed-management.module": [
		"../../../../../src/app/ipd/bed-management/bed-management.module.ts",
		"bed-management.module"
	],
	"app/ipd/discharge-summary-new/discharge-summary-new.module": [
		"../../../../../src/app/ipd/discharge-summary-new/discharge-summary-new.module.ts"
	],
	"app/ipd/discharge-summary/discharge-summary.module": [
		"../../../../../src/app/ipd/discharge-summary/discharge-summary.module.ts"
	],
	"app/ipd/discharge/discharge.module": [
		"../../../../../src/app/ipd/discharge/discharge.module.ts"
	],
	"app/ipd/ipd-advanced/ipd-advanced.module": [
		"../../../../../src/app/ipd/ipd-advanced/ipd-advanced.module.ts",
		"common",
		"ipd-advanced.module"
	],
	"app/ipd/ipd-sponsor-combination/ipd-sponsor-combination.module": [
		"../../../../../src/app/ipd/ipd-sponsor-combination/ipd-sponsor-combination.module.ts",
		"common",
		"ipd-sponsor-combination.module"
	],
	"app/ipd/patient-emr-dashboard/patient-emr-dashboard.module": [
		"../../../../../src/app/ipd/patient-emr-dashboard/patient-emr-dashboard.module.ts",
		"patient-emr-dashboard.module"
	],
	"app/ipd/time-base-charges/time-base-charges.module": [
		"../../../../../src/app/ipd/time-base-charges/time-base-charges.module.ts",
		"time-base-charges.module"
	],
	"app/ipd/trn-admission-cancel-list/trn-admission-cancel-list.module": [
		"../../../../../src/app/ipd/trn-admission-cancel-list/trn-admission-cancel-list.module.ts",
		"common",
		"trn-admission-cancel-list.module"
	],
	"app/ipd/trn-dischargelist/trn-dischargelist.module": [
		"../../../../../src/app/ipd/trn-dischargelist/trn-dischargelist.module.ts"
	],
	"app/login/login.module": [
		"../../../../../src/app/login/login.module.ts"
	],
	"app/nursingstation/documents/documents.module": [
		"../../../../../src/app/nursingstation/documents/documents.module.ts",
		"common",
		"documents.module"
	],
	"app/nursingstation/nursingconsole/nursingconsole.module": [
		"../../../../../src/app/nursingstation/nursingconsole/nursingconsole.module.ts",
		"common",
		"nursingconsole.module"
	],
	"app/nursingstation/staffdirectory/staffdirectory.module": [
		"../../../../../src/app/nursingstation/staffdirectory/staffdirectory.module.ts",
		"staffdirectory.module"
	],
	"app/operation-theater/ot-details/ot-details.module": [
		"../../../../../src/app/operation-theater/ot-details/ot-details.module.ts",
		"common",
		"ot-details.module"
	],
	"app/operation-theater/ot-request/ot-request.module": [
		"../../../../../src/app/operation-theater/ot-request/ot-request.module.ts",
		"common",
		"ot-request.module"
	],
	"app/operation-theater/ot-schedule/ot-schedule.module": [
		"../../../../../src/app/operation-theater/ot-schedule/ot-schedule.module.ts",
		"common",
		"ot-schedule.module"
	],
	"app/operation-theater/otdetails-list/otdetails-list.module": [
		"../../../../../src/app/operation-theater/otdetails-list/otdetails-list.module.ts",
		"otdetails-list.module"
	],
	"app/operation-theater/otshedule-list/otshedule-list.module": [
		"../../../../../src/app/operation-theater/otshedule-list/otshedule-list.module.ts",
		"common",
		"otshedule-list.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "../../../../../src/$$_gendir lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/$$_gendir lazy
// module id = ../../../../../src/$$_gendir lazy recursive
// module chunks = main